const minus_btn = document.querySelectorAll('.quantity-selector__button_minus');
const plus_btn = document.querySelectorAll('.quantity-selector__button_plus');

plus_btn.forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    const variant_id = btn.getAttribute('data-variant');
    const qtd = parseInt(btn.getAttribute('data-quantity'));
    const new_qtd = qtd + 1;

    const updates = {
      [variant_id]: new_qtd
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(cart => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      window.location.reload();
    })
    .catch(err => console.error('Error:', err));
  });
});

minus_btn.forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();
    const variant_id = btn.getAttribute('data-variant');
    const qtd = parseInt(btn.getAttribute('data-quantity'));
    const new_qtd = qtd > 1 ? qtd - 1 : 0;

    const updates = {
      [variant_id]: new_qtd
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(cart => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      window.location.reload();
    })
    .catch(err => console.error('Error:', err));
  });
});
